<div class="text-center">
  <ng-container *ngIf="!widerruf">
    <h5>Vielen Dank!</h5>
    <p>
      Sie haben Ihre Teilnahme am Versorgungsvertrag erfolgreich bestätigt.<br/>
      Ihre Teilnahmeerklärung können Sie innerhalb der nächsten 14 Tage
      herunterladen.<br/>
      Sie erhalten gleich auch noch eine E-Mail zur Bestätigung.
    </p>
  </ng-container>
  <ng-container *ngIf="widerruf">
    <h5>Sie sind eingeschrieben.</h5>
    <p>
      Sie haben Ihre Teilnahme am Versorgungsvertrag erfolgreich bestätigt.<br/>
      Ihre Teilnahmeerklärung können Sie ab dem
      {{ state?.sign_datetime | amDateFormat: "DD.MM.YYYY" }} 14 Tage lang
      herunterladen.<br/>
      Innerhalb dieses Zeitraums können Sie hier Ihre Teilnahme widerrufen.
    </p>
  </ng-container>
  <div>
    <button
      (click)="downloadTneClicked.emit()"
      [disabled]="!teilnahmeerklaerung"
      class="btn btn-primary"
    >
      Teilnahmeerklärung<span
    >&nbsp;<fa-icon
      *ngIf="!teilnahmeerklaerung"
      [icon]="loadingIcon"
      animation="spin-pulse"
    ></fa-icon
    ></span></button
    >
    <br class="d-md-none"/>
    <button
      (click)="widerrufClicked.emit()"
      *ngIf="widerruf"
      class="btn btn-primary ms-md-3 mt-3 mt-md-0"
    >
      Teilnahme widerrufen
    </button
    >
    <br class="d-md-none"/>
    <button
      (click)="abmeldenClicked.emit()"
      class="btn btn-primary ms-md-3 mt-3 mt-md-0"
    >
      Abmelden
    </button>
  </div>
</div>
